<template>
  <PopperContainer
    :value="visible"
    @input="$emit('update:visible', $event)"
    @confirm="onConfirm"
    round
  >
    <van-picker
      v-if="visible"
      ref="speedPicker"
      :columns="options"
      :default-index="defaultIndex"
      @change="onPick"
    />
  </PopperContainer>
</template>
<script>
import PopperContainer from "../popper-container/popper-container";
export default {
  components: {
    PopperContainer,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedValue: "",
    };
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        const index = this.options.indexOf(this.value);
        if (index === -1 && this.options.length > 0) {
          this.defaultIndex = 0;
          this.selectedValue = this.options[0];
        } else {
          this.defaultIndex = index;
          this.selectedValue = this.value;
        }
      },
    },
  },
  methods: {
    onConfirm() {
      if (this.selectedValue !== this.value) {
        this.$emit("change", this.selectedValue);
      }
    },
    onPick(e, val, index) {
      this.selectedValue = this.options[index];
    },
  },
};
</script>
